<template>
    <ChatIcon
        :unread-messages-amount="unreadMessages"
        class="cursor-pointer"
        :size="iconSize"
        @click="handleIconClick"
    />
</template>

<script setup lang="ts">
import ChatIcon, { type ChatIconProps } from '@atoms/ChatIcon/ChatIcon.vue';

type ChatIconWrapperProps = {
    iconSize: ChatIconProps['size'];
};

const { $api } = useNuxtApp();

withDefaults(defineProps<ChatIconWrapperProps>(), { iconSize: '14' });

const { data } = await useAsyncData('unreadMessages', () =>
    $api.chat.getUnreadMessagesAmount()
);

const unreadMessages = computed(() => data.value?.count || 0);

const handleIconClick = async () => {
    await navigateTo({ name: 'chats' });
};
</script>
